import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { QRCodeModule } from 'angularx-qrcode';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DateTodayModule } from 'src/app/core/common/datetoday/datetoday.module';
import { KeyboardService } from 'src/app/core/common/keyboard/keyboard.service';
import { NumpadModule } from 'src/app/core/common/numpad/numpad.module';
import { ComponentsModule } from 'src/app/core/components/components.module';
import { PageModule } from 'src/app/page/page.module';
import { SharedModule } from '../[module]/shared.module';
import { CountryComponent } from './country/country.component';
import { OptionsComponent } from './options.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    OptionsComponent,
    CountryComponent
  ],
  imports: [
    CommonModule,
    PageModule,
    DateTodayModule,
    SharedModule,
    QRCodeModule,
    ComponentsModule,
    NumpadModule,
    NgScrollbarModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [OptionsComponent],
  providers: []
})
export class OptionsModule { }
